const showElement = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
        element.style.display = 'block';
    }
};

export default showElement;